<ng-template [ngIf]="isLoaded" [ngIfElse]="loading">
  <google-chart #chart [title]="title" [type]="type" [data]="data" [options]="options" [width]="width"
    [height]="height">
  </google-chart>
</ng-template>

<ng-template #loading>
  <app-loading></app-loading>
</ng-template>